<template>
  <div id="app">
    <TheHeader />
    <main>
      <router-view />
    </main>
    <TheFooter />
    <ScrollToTop />
  </div>
</template>

<script>
import TheHeader from '@/components/layout/TheHeader.vue'
import TheFooter from '@/components/layout/TheFooter.vue'
import ScrollToTop from '@/components/common/ScrollToTop.vue'

export default {
  name: 'App',
  components: {
    TheHeader,
    TheFooter,
    ScrollToTop // Ajoutez-le aux components
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  background: linear-gradient(to bottom right, #ffffff, #f0f4ff);
  min-height: 100vh;
}

main {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
</style>